import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrProgressCircle } from "../data";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
import { GrIcon } from "../icons/GrIcon";
const StyledButton = styled("button")(({ size, color, variant, isLoading, disabled, style, fullWidth }) => {
    return {
        display: "inline-flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "6px",
        border: "none",
        gap: "10px",
        color: palette.white,
        minWidth: (size === "large" && "74px") || (size === "small" && "55px") || "66px",
        width: (fullWidth && "100%") || (style === null || style === void 0 ? void 0 : style.width),
        cursor: (disabled && "not-allowed") || (isLoading && "progress") || "pointer",
        ...(size === "large" && {
            padding: variant === "outlined" ? "9px 15px" : "10px 16px",
            height: "40px",
        }),
        ...(size === "medium" && {
            padding: variant === "outlined" ? "5px 11px" : "6px 12px",
            height: "32px",
        }),
        ...(size === "small" && {
            padding: variant === "outlined" ? "2px 9px" : "3px 10px",
            height: "24px",
        }),
        ".GrButton-content": {
            position: "relative",
            padding: "0 2px",
            ...(size === "large" && {
                ...typography["Content.Subtitle02"],
            }),
            ...(size === "medium" && {
                ...typography["Content.Subtitle03"],
            }),
            ...(size === "small" && {
                ...typography["Content.Subtitle04"],
            }),
        },
        ...(color === "primary" && {
            ...(variant === "contained" && {
                backgroundColor: palette.blue050,
                "&:hover": {
                    backgroundColor: "#1F81A5",
                },
                "&:active": {
                    backgroundColor: "#1A6C8A",
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: palette.white,
                color: palette.blue050,
                border: `1px solid ${palette.blue050}`,
                "&:hover": {
                    backgroundColor: "#E9F5F9",
                },
                "&:active": {
                    backgroundColor: "#A8D7E8",
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette["maven-blue-dark"],
                "&:hover": {
                    backgroundColor: "#E9F5F9",
                },
                "&:active": {
                    backgroundColor: "#A8D7E8",
                },
            }),
        }),
        ...(color === "grey" && {
            ...(variant === "contained" && {
                backgroundColor: palette.grey020,
                color: palette.grey100,
                "&:hover": {
                    backgroundColor: "#D8DADC",
                },
                "&:active": {
                    backgroundColor: "#C0C1C3",
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: palette.white,
                color: palette.grey100,
                border: `1px solid ${palette.grey025}`,
                "&:hover": {
                    backgroundColor: "#F5F6F7",
                },
                "&:active": {
                    backgroundColor: "#E9EBED",
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette.grey100,
                "&:hover": {
                    backgroundColor: "#F5F6F7",
                },
                "&:active": {
                    backgroundColor: "#E9EBED",
                },
            }),
        }),
        ...(color === "orange" && {
            ...(variant === "contained" && {
                backgroundColor: palette.orange050,
                "&:hover": {
                    backgroundColor: "#D3600E",
                },
                "&:active": {
                    backgroundColor: "#B0500C",
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: palette.white,
                color: palette.orange050,
                border: `1px solid ${palette.orange050}`,
                "&:hover": {
                    backgroundColor: "#FFF3EA",
                },
                "&:active": {
                    backgroundColor: "#FFDBC1",
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette["warning-primary"],
                "&:hover": {
                    backgroundColor: "#FFF3EA",
                },
                "&:active": {
                    backgroundColor: "#FFDBC1",
                },
            }),
        }),
        ...(color === "red" && {
            ...(variant === "contained" && {
                backgroundColor: palette.red050,
                "&:hover": {
                    backgroundColor: "#D24148",
                },
                "&:active": {
                    backgroundColor: "#AF363C",
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: palette.white,
                color: palette.red050,
                border: `1px solid ${palette.red040}`,
                "&:hover": {
                    backgroundColor: "#FFF0F1",
                },
                "&:active": {
                    backgroundColor: "#FFDADC",
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette.red050,
                "&:hover": {
                    backgroundColor: "#FFF0F1",
                },
                "&:active": {
                    backgroundColor: "#FFDADC",
                },
            }),
        }),
        ...(color === "green" && {
            ...(variant === "contained" && {
                backgroundColor: palette.green050,
                "&:hover": {
                    backgroundColor: "#1E873C",
                },
                "&:active": {
                    backgroundColor: "#16652D",
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: palette.white,
                color: palette.green050,
                border: `1px solid ${palette.green040}`,
                "&:hover": {
                    backgroundColor: "#ECF8F0",
                },
                "&:active": {
                    backgroundColor: "#C6ECD1",
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette.green050,
                "&:hover": {
                    backgroundColor: "#ECF8F0",
                },
                "&:active": {
                    backgroundColor: "#C6ECD1",
                },
            }),
        }),
        ...(color === "white" && {
            ...(variant === "contained" && {
                backgroundColor: palette.white,
                color: palette.grey100,
                "&:hover": {
                    backgroundColor: palette.grey025,
                },
                "&:active": {
                    backgroundColor: palette.grey040,
                },
            }),
            ...(variant === "outlined" && {
                backgroundColor: "transparent",
                color: palette.white,
                border: `1px solid ${palette.white}`,
                "&:hover": {
                    backgroundColor: palette.grey050,
                },
                "&:active": {
                    backgroundColor: palette.grey060,
                },
            }),
            ...(variant === "text" && {
                backgroundColor: "transparent",
                color: palette.white,
                "&:hover": {
                    backgroundColor: palette.grey050,
                },
                "&:active": {
                    backgroundColor: palette.grey060,
                },
            }),
        }),
        ...(disabled && {
            backgroundColor: palette.grey020,
            color: palette.grey030,
            border: `1px solid ${palette.grey025}`,
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: palette.grey020,
                color: palette.grey030,
                border: `1px solid ${palette.grey025}`,
                cursor: "not-allowed",
            },
            "&:active": {
                backgroundColor: palette.grey020,
                color: palette.grey025,
                border: `1px solid ${palette.grey025}`,
                cursor: "not-allowed",
            },
        }),
        ...style,
    };
});
export function GrButton({ size = "medium", color = "primary", variant = "contained", role = "button", children, startIcon, startIconSize, endIcon, endIconSize, isLoading, fullWidth, disabled = false, className, contentStyle, onClick, type, ...others }) {
    const handleClick = (e) => {
        if (!disabled && !isLoading && onClick) {
            onClick(e);
        }
    };
    return (_jsxs(StyledButton, { role: role, "data-testid": role, type: type, className: classNames("GrButton", className), size: size, color: color, variant: variant, startIcon: startIcon, endIcon: endIcon, isLoading: isLoading, fullWidth: fullWidth, disabled: disabled, onClick: handleClick, ...others, children: [!isLoading && startIcon && (_jsx(GrIcon, { type: startIcon, size: startIconSize ? startIconSize : size === "small" ? 14 : 16, color: getIconColor(color, variant, !!disabled || !!isLoading) })), isLoading && (_jsx(GrProgressCircle, { variant: "indeterminate", size: size === "small" ? 14 : 16, hasBackgroundColor: true, color: getIconColor(color, variant, !!disabled) })), children && (_jsx("div", { className: "GrButton-content", style: contentStyle, children: children })), endIcon && (_jsx(GrIcon, { type: endIcon, size: endIconSize ? endIconSize : size === "small" ? 14 : 16, color: getIconColor(color, variant, !!disabled) }))] }));
}
function getIconColor(color, variant, disabled) {
    if (disabled)
        return "grey025";
    if (color === "grey")
        return "grey070";
    if (color === "white")
        return variant === "contained" ? "grey070" : "white";
    if (variant === "contained")
        return "white";
    if (color === "primary")
        return "maven-blue-dark";
    if (color === "orange")
        return "warning-primary";
    if (color === "red")
        return "negative-primary";
    if (color === "green")
        return "positive-primary";
    return "white";
}
//# sourceMappingURL=GrButton.js.map